import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { User } from '../models/entities/user';
import { Invite } from '../models/entities/invite';
import { firstValueFrom, Observable } from 'rxjs';
import { ApiGetSuccessResponse } from '../models/common/api-get-success-response';
import { CreateInviteRequest } from '../requests/create-invite.request';
import { VerifyAcceptInviteRequest } from '../requests/verify-accept-invite.request';

@Injectable({
  providedIn: 'root',
})
export class InvitesService {
  constructor(private apiService: ApiService) {}

  create(createInviteDto: CreateInviteRequest) {
    return this.apiService.post('invites', createInviteDto);
  }

  findAll(): Observable<ApiGetSuccessResponse<Invite[]>> {
    return this.apiService.get('invites');
  }

  verify(
    verifyAcceptInviteDto: VerifyAcceptInviteRequest,
  ): Promise<ApiGetSuccessResponse<Invite>> {
    return firstValueFrom(
      this.apiService.get('invites/verify', verifyAcceptInviteDto),
    );
  }

  accept(verifyAcceptInviteDto: VerifyAcceptInviteRequest): Promise<User> {
    return this.apiService.post('invites/accept', verifyAcceptInviteDto);
  }

  delete(id: number) {
    return this.apiService.delete('invites/' + id);
  }
}
